import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { MapboxGet } from "libs/services/mapbox";
import { MAPBOX } from "src/common/libs/config/mapbox.config";
import { reportLog } from "src/common/libs/utils/logs";
import { GeocodingResponse } from "src/common/types/response/mapboxGeocoding";
import { MapboxSearchResponse } from "src/common/types/response/mapboxSearch";

export const searchAddressMapbox = createAsyncThunk(
  "mapbox/searchAddressMapbox",
  async (
    { search, proximity }: { search: string; proximity: string },
    thunkAPI
  ) => {
    try {
      const response = await MapboxGet<MapboxSearchResponse>(MAPBOX.search, {
        q: search,
        proximity,
      });
      return response.data;
    } catch (error) {
      reportLog({
        error: error,
        location: "features/mapbox->searchAddressMapbox[62]",
        body: { search, proximity },
      });
      return null;
    } finally {
      // thunkAPI.dispatch(setLoading(false));
    }
  }
);

export const geocoding = createAsyncThunk(
  "mapbox/geocoding",
  async ({ lat, lon }: { lat: string; lon: string }, thunkAPI) => {
    try {
      const response = await MapboxGet<GeocodingResponse>(
        `${MAPBOX.geocoding}`,
        { longitude: lon, latitude: lat, limit: 1 }
      );
      return response.data;
    } catch (error) {
      reportLog({
        error: error,
        location: "features/mapbox->geocoding[42]",
        body: { lat, lon },
      });
      return null;
    } finally {
      // thunkAPI.dispatch(setLoading(false));
    }
  }
);

const initialState: any = {};

export const mapboxSlice = createSlice({
  name: "mapbox",
  initialState,
  reducers: {},
});

export const {} = mapboxSlice.actions;

export default mapboxSlice.reducer;
